/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkflowModelEntity } from './WorkflowModelEntity';
import {
    WorkflowModelEntityFromJSON,
    WorkflowModelEntityFromJSONTyped,
    WorkflowModelEntityToJSON,
    WorkflowModelEntityToJSONTyped,
} from './WorkflowModelEntity';

/**
 * 
 * @export
 * @interface ListWorkflowModelsResult
 */
export interface ListWorkflowModelsResult {
    /**
     * ワークフローモデル一覧
     * @type {Array<WorkflowModelEntity>}
     * @memberof ListWorkflowModelsResult
     */
    models: Array<WorkflowModelEntity>;
    /**
     * 総数
     * @type {number}
     * @memberof ListWorkflowModelsResult
     */
    total: number;
}

/**
 * Check if a given object implements the ListWorkflowModelsResult interface.
 */
export function instanceOfListWorkflowModelsResult(value: object): value is ListWorkflowModelsResult {
    if (!('models' in value) || value['models'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function ListWorkflowModelsResultFromJSON(json: any): ListWorkflowModelsResult {
    return ListWorkflowModelsResultFromJSONTyped(json, false);
}

export function ListWorkflowModelsResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListWorkflowModelsResult {
    if (json == null) {
        return json;
    }
    return {
        
        'models': ((json['models'] as Array<any>).map(WorkflowModelEntityFromJSON)),
        'total': json['total'],
    };
}

export function ListWorkflowModelsResultToJSON(json: any): ListWorkflowModelsResult {
    return ListWorkflowModelsResultToJSONTyped(json, false);
}

export function ListWorkflowModelsResultToJSONTyped(value?: ListWorkflowModelsResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'models': ((value['models'] as Array<any>).map(WorkflowModelEntityToJSON)),
        'total': value['total'],
    };
}

